import { Link } from 'react-router-dom';
import { Shield, ArrowLeft, BookOpen, Clock } from 'lucide-react';
import AppFooter from '../components/AppFooter';
import { GUIDES } from '../data/guides';

export default function ResourcesPage() {
  return (
    <div className="min-h-screen bg-[#F5F5F5]" data-testid="resources-page">
      <header className="glass-header sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <Link to="/" className="flex items-center" data-testid="home-link">
              <Shield className="w-8 h-8 text-[#B76E79]" strokeWidth={1.5} />
              <span className="ml-2 font-['Playfair_Display'] text-xl font-semibold text-[#36454F]">
                Selah Slate&trade;
              </span>
            </Link>
            <Link
              to="/"
              className="text-sm text-[#36454F]/70 hover:text-[#36454F] font-['Manrope'] flex items-center"
              data-testid="back-link"
            >
              <ArrowLeft className="w-4 h-4 mr-1" strokeWidth={1.5} />
              Back
            </Link>
          </div>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <div className="mb-10 animate-fade-in-up">
          <p className="text-xs uppercase tracking-wider text-[#B76E79] font-['Manrope'] font-medium mb-2">
            Free Resources
          </p>
          <h1 className="font-['Playfair_Display'] text-4xl font-semibold text-[#36454F]">
            Credit Dispute Guides
          </h1>
          <p className="mt-3 text-[#36454F]/60 font-['Manrope'] leading-relaxed">
            Plain-English, no-cost guides to disputing credit report errors yourself — your rights
            under the FCRA, letters that actually work, and what to do at every stage.
          </p>
        </div>

        <div className="space-y-5">
          {GUIDES.map((g, i) => (
            <Link
              key={g.slug}
              to={`/resources/${g.slug}`}
              data-testid={`guide-card-${g.slug}`}
              className="block bg-white border border-[#36454F]/10 rounded-sm p-6 sm:p-8 hover:border-[#B76E79]/40 hover:shadow-md transition-all animate-fade-in-up"
              style={{ animationDelay: `${i * 80}ms` }}
            >
              <div className="flex items-center gap-3 mb-2 text-xs font-['Manrope']">
                <span className="px-2 py-0.5 rounded bg-[#B76E79]/10 text-[#B76E79] font-semibold uppercase tracking-wider">
                  {g.category}
                </span>
                <span className="flex items-center text-[#36454F]/40">
                  <Clock className="w-3.5 h-3.5 mr-1" strokeWidth={1.5} />
                  {g.readTime}
                </span>
              </div>
              <h2 className="font-['Playfair_Display'] text-xl sm:text-2xl font-semibold text-[#36454F] mb-2">
                {g.title}
              </h2>
              <p className="text-sm text-[#36454F]/60 font-['Manrope'] leading-relaxed">{g.description}</p>
              <span className="inline-flex items-center mt-4 text-sm text-[#B76E79] font-['Manrope'] font-semibold">
                <BookOpen className="w-4 h-4 mr-1.5" strokeWidth={1.5} />
                Read the guide
              </span>
            </Link>
          ))}
        </div>

        <div className="mt-10 p-6 sm:p-8 bg-[#36454F] rounded-sm text-center animate-fade-in-up" data-testid="resources-cta">
          <p className="font-['Playfair_Display'] text-xl font-semibold text-[#E0BFB8] mb-2">
            Ready to clear your slate?
          </p>
          <p className="text-sm text-white/70 font-['Manrope'] mb-5 max-w-md mx-auto">
            Selah Slate turns these guides into action — upload your report, generate your letters,
            and track every response. Free forever.
          </p>
          <Link
            to="/register"
            data-testid="resources-cta-register"
            className="inline-block px-6 py-3 bg-[#B76E79] text-white text-sm font-['Manrope'] font-semibold rounded-sm hover:bg-[#a35d68] transition-colors"
          >
            Start free — no credit card
          </Link>
        </div>
      </main>

      <AppFooter />
    </div>
  );
}
